import { CheckCircle2, Mail, Star } from "lucide-react";
import LegalLayout from "./LegalLayout";
import ContactForm from "./ContactForm";
import useSeo from "../hooks/useSeo";

export default function Kontakt() {
  useSeo({
    title: "Kontakt | IYM – Im Your Man Webdesign & Google Ads",
    description:
      "Kostenloses Erstgespräch mit IYM. Sag uns, was du brauchst – Webdesign, Google Ads oder SEO – und wir melden uns innerhalb von 24 Stunden.",
    path: "/kontakt",
  });

  return (
    <LegalLayout title="Lass uns dein Projekt starten.">
      <div className="-mt-4">
        <p className="mb-8 max-w-2xl text-lg leading-relaxed text-[#4a453d]">
          Fülle das Formular aus – wir melden uns innerhalb von 24 Stunden mit einer ehrlichen
          Einschätzung und einem klaren Angebot. Kostenlos und unverbindlich.
        </p>

        <ul className="mb-10 grid gap-3 text-[15px] text-[#4a453d] sm:grid-cols-2">
          {[
            "Antwort innerhalb von 24 Std.",
            "Kostenloses Erstgespräch",
            "Individuelles Angebot",
            "Full-Service aus einer Hand",
          ].map((f) => (
            <li key={f} className="flex items-center gap-2">
              <CheckCircle2 className="h-5 w-5 shrink-0 text-[#2c3bff]" />
              {f}
            </li>
          ))}
        </ul>

        <ContactForm
          className="rounded-2xl border border-black/10 bg-white p-6 shadow-sm md:p-8"
          redirectTo="/kontakt/danke"
        />

        <div className="mt-12 flex flex-wrap items-center gap-6 border-t border-black/10 pt-8 text-sm text-[#4a453d]">
          <div className="flex items-center gap-1.5">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-4 w-4 fill-[#febc2e] text-[#febc2e]" />
            ))}
            <span className="ml-1 font-mono text-xs">4.9/5 Kundenbewertung</span>
          </div>
          <a
            href="mailto:info.iym24@gmail.com"
            className="flex items-center gap-2 font-mono text-xs uppercase tracking-wider hover:text-ink"
          >
            <Mail className="h-4 w-4" />
            info.iym24@gmail.com
          </a>
        </div>
      </div>
    </LegalLayout>
  );
}
